import { Button, useTheme } from '@material-ui/core';
import React from 'react';

interface LinkToDetailButtonProps {
  onClick: () => void;
}
export const LinkToDetailButton = ({ onClick }: LinkToDetailButtonProps) => {
  const { palette } = useTheme();
  return (
    <Button
      onClick={onClick}
      style={{
        minWidth: '4px',
        maxWidth: '24px',
        maxHeight: '24px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        cursor: 'pointer',
        marginLeft: '6px',
      }}
    >
      <i
        className="material-icons-outlined"
        style={{
          verticalAlign: 'sub',
          fontSize: '20px',
          paddingInline: '2px',
          color: palette.text.primary,
        }}
      >
        {'chevron_right'}
      </i>
    </Button>
  );
};
